/* eslint-disable*/
import React, {Component} from 'react';
import Template from '../Template';
import CdpReports from '../../components/CdpReports';
import ErrorBoundary from "../../components/ErrorBoundary";

export default class SavedReportsCdp extends Component {
    render() {
        return (
            <Template activeLink='cdp'>
                <ErrorBoundary>
                    <CdpReports {...this.props} saved={true}/>
                </ErrorBoundary>
            </Template>
        );
    }
}
